import { render, staticRenderFns } from "./Leaderboards.vue?vue&type=template&id=0265372a&"
import script from "./Leaderboards.vue?vue&type=script&lang=js&"
export * from "./Leaderboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports